<div class="bg-abi-light min-vh-100 d-flex flex-column pt-0 pb-3 pb-md-5 pt-md-5 py-5">
	<div class="container px-0 flex-grow-1 d-flex flex-column flex-md-row">
		<!-- SIDEBAR DESTRA -->
		<div class="order-0 order-md-1 w-md-35 px-0 pt-3 pt-md-5 pb-2 pb-md-5 py-5 bg-abi-step custom-mobile d-flex flex-column">
			<div class="d-flex flex-column flex-grow-1 h-100">
				<!-- Logo -->
				<div class="mx-3 mx-md-0">
					<div class="col-12 d-flex justify-content-between justify-content-md-center">
						@if (isImatra) {
							@if (logoUrl) {
								<img [src]="logoUrl" class="img-sidebar-logo" alt="logo" />
							}
						} @else {
							<img src="/assets/images/PIB Italia Broker_logo.png" class="img-sidebar-logo" alt="logo" />
						}
						<app-change-language class="only-mobile select-transparent"></app-change-language>
					</div>
				</div>
				<div class="only-desktop">
					<hr class="text-abi-light" />
					<div class="col-12 d-flex justify-content-center text-center mt-2">
						<span class="text-abi-dark fs-14 fw-500">
							Richiesta di recesso
							<br />
							dalla polizza assicurativa
						</span>
					</div>
					<div class="col-12 d-flex justify-content-center text-center mt-2">
						<span class="text-abi-dark fs-12 fw-light">Compila il modulo per procedere.</span>
					</div>
				</div>
				<!-- Immagine illustrativa in fondo -->
				<div class="col-12 d-flex justify-content-center align-items-end mt-auto">
					<img [src]="stepImage" width="250" class="only-desktop" alt="" />
				</div>
			</div>
			<hr class="only-mobile mx-2 pt-2" />
		</div>

		<!-- AREA FORM SINISTRA -->
		<div class="order-1 order-md-0 w-100 flex-grow-1 d-flex flex-column me-md-4 px-3 px-md-0">
			@if (status === 'success') {
				<div class="col-12 d-flex flex-column align-items-center justify-content-center flex-grow-1 text-center py-5">
					<i class="bi bi-check-circle-fill fs-1 mb-3 text-abi-primary"></i>
					<h2 class="fw-500 fs-28 text-abi-dark">Richiesta inviata</h2>
					<p class="fw-light fs-15 text-abi-dark mt-2">
						La tua richiesta di recesso è stata ricevuta.
						<br />
						Verrai contattato al più presto.
					</p>
				</div>
			} @else {
				<div class="col-12 d-flex justify-content-center text-center">
					<h1 class="fw-500 fs-30 text-abi-dark">Richiesta di recesso</h1>
				</div>
				<div class="col-12 d-flex justify-content-center text-center">
					<span class="fw-light fs-15 text-abi-dark">Compila i dati richiesti per procedere con il recesso dalla polizza.</span>
				</div>

				<div class="col-12 col-md-7 mx-md-auto my-4">
					@if (status === 'error') {
						<div class="alert alert-highlight mb-3" role="alert">
							<div class="d-flex align-items-center">
								<i class="bi bi-exclamation-triangle me-2"></i>
								Si è verificato un errore durante l'invio. Riprova più tardi.
							</div>
						</div>
					}

					<div class="card form-card p-3">
						<span class="fs-14 fw-bold text-abi-secondary">Dati per il recesso</span>
						<p class="fw-light fs-14 m-0">Inserisci i dati personali e i riferimenti della polizza.</p>
						<hr />
						@if (status === 'prefilling') {
							<div class="d-flex justify-content-center py-3">
								<span class="spinner-border text-abi-primary" role="status"></span>
							</div>
						}
						<form [formGroup]="form" (ngSubmit)="invia()" novalidate [class.d-none]="status === 'prefilling'">
							<div class="col-12 mb-3">
								<label for="firstName" class="form-label mb-0">Nome *</label>
								<input
									id="firstName"
									type="text"
									class="form-control"
									[class.is-invalid]="isInvalid('firstName')"
									formControlName="firstName"
									placeholder="Inserisci il tuo nome" />
								@if (isInvalid('firstName')) {
									<p class="mt-1 mb-0 fs-12 text-abi-alert">Campo obbligatorio</p>
								}
							</div>

							<div class="col-12 mb-3">
								<label for="lastName" class="form-label mb-0">Cognome *</label>
								<input
									id="lastName"
									type="text"
									class="form-control"
									[class.is-invalid]="isInvalid('lastName')"
									formControlName="lastName"
									placeholder="Inserisci il tuo cognome" />
								@if (isInvalid('lastName')) {
									<p class="mt-1 mb-0 fs-12 text-abi-alert">Campo obbligatorio</p>
								}
							</div>

							<div class="row mb-3">
								<div class="col-12 col-sm-6">
									<label for="phone" class="form-label mb-0">Telefono *</label>
									<input id="phone" type="tel" class="form-control" [class.is-invalid]="isInvalid('phone')" formControlName="phone" placeholder="Es. 3391234567" />
									@if (isInvalid('phone')) {
										<p class="mt-1 mb-0 fs-12 text-abi-alert">Campo obbligatorio</p>
									}
								</div>
								<div class="col-12 col-sm-6 mt-3 mt-sm-0">
									<label for="email" class="form-label mb-0">Email *</label>
									<input id="email" type="email" class="form-control" [class.is-invalid]="isInvalid('email')" formControlName="email" placeholder="Es. mario.rossi@email.it" />
									@if (isInvalid('email')) {
										<p class="mt-1 mb-0 fs-12 text-abi-alert">Inserisci un'email valida</p>
									}
								</div>
							</div>

							<div class="col-12 mb-3">
								<label for="policyNumber" class="form-label mb-0">Numero polizza *</label>
								<input
									id="policyNumber"
									type="text"
									class="form-control"
									[class.is-invalid]="isInvalid('policyNumber')"
									formControlName="policyNumber"
									placeholder="Numero polizza" />
								@if (isInvalid('policyNumber')) {
									<p class="mt-1 mb-0 fs-12 text-abi-alert">Campo obbligatorio</p>
								}
							</div>

							<div class="col-12 d-flex justify-content-end">
								<button class="btn btn-abi-primary" type="submit" [disabled]="status === 'loading'">
									@if (status === 'loading') {
										<span class="spinner-border spinner-border-sm me-2" role="status"></span>
									}
									Invia
								</button>
							</div>
						</form>
					</div>
				</div>
			}

			<div class="col-12 mt-auto">
				<hr />
			</div>
		</div>
	</div>

	<div class="container px-2 px-md-0 col-12 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center mt-0 mt-md-4 gap-2">
		<span class="text-abi-dark fs-11 fw-100">
			@if (isImatra) {
				Imatra - PIB Italia broker © 2026 | All rights reserved
			} @else {
				PIB Italia broker © 2026 | All rights reserved
			}
		</span>
		@if (isImatra) {
			<div class="d-flex align-items-center gap-2">
				<span class="text-muted fs-10 d-none d-lg-inline">Powered by</span>
				<img src="/assets/images/logo_pib.svg" alt="PIB Italia broker" class="pib-footer-logo" />
			</div>
		} @else {
			<div class="d-flex align-items-center gap-3">
				<img src="/assets/images/PIB Italia Broker_logo.png" alt="PIB Group" class="landing-logo-xl" />
				<span class="landing-header-divider">|</span>
				<div class="d-flex align-items-center gap-2">
					<span class="landing-footer-powered-dark">IN PARTNERSHIP WITH</span>
					<img src="/assets/img/aic/logo.png" alt="AIC" class="landing-logo-footer landing-logo-circle bg-white p-1" />
				</div>
			</div>
		}
		<app-change-language class="only-desktop"></app-change-language>
	</div>
</div>
